import { environment } from 'src/environments/environment';
import { Device, DeviceInfo } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';

export class Util {
  /**
   * Retorna el año actual tomado del sistema.
   * @returns {string} - Año Actual.
   */
  public static get getYear(): string {
    const Year: string = new Date().getFullYear().toString();
    return Year;
  }

  /**
   * Retorna el nombre de la Compañia.
   * @returns {string} Nombre Compañia.
   */
  public static readonly getCompanyName = 'Telosity';

  /**
   * Retorna el nombre y apellido dado capitalizado.
   * @param {string} name - Nombre
   * @param {string} last_name - Apellido
   * @returns {string} - Nombre Capitalizado
   */
  public static capitalizeName(name: string, last_name: string): string {
    return [name, last_name]
      .map((value: string) => value.toLocaleLowerCase())
      .map((value: string) => {
        const Words: string[] = value.split(' ');
        return Words.map((value: string) => {
          const [FirstLetter, ...Word]: string[] = value.split('');
          return `${FirstLetter.toUpperCase()}${Word.join('')}`;
        }).join(' ');
      })
      .join(' ');
  }

  /**
   * Valida la compilación de la plataforma.
   * @returns {boolean}
   */
  public static get isTest(): boolean {
    return environment.isTest;
  }

  /**
   * Devuelve la plataforma en la cual corre la aplicación.
   * @returns {Peomise<string>}
   */
  public static async RunningPlatform(): Promise<string> {
    //también hay un método más abajo que retorna booleano
    const Info: DeviceInfo = await Device.getInfo();
    return Info.platform;
  }

  /**
   * Convierte una imagen en un código Base64
   * @param {string} imageUrl - Url de la imagen
   * @returns {Promise<string>} - Base64
   */
  public static async convertImageToBase64(imageUrl: string): Promise<string> {
    try {
      const Response: Response = await fetch(imageUrl);
      const Blob: Blob = await Response.blob();
      return new Promise((resolve, reject) => {
        const Reader: FileReader = new FileReader();
        Reader.onloadend = () =>
          typeof Reader.result === 'string'
            ? resolve(Reader.result)
            : reject(new Error('Failed to convert blob to base64 string.'));
        Reader.onerror = reject;
        Reader.readAsDataURL(Blob);
      });
    } catch (error) {
      console.error('Error al cargar o convertir la imagen:', error);
      throw error;
    }
  }
}

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
